import { Container } from '@mui/material'
import React from 'react'
import NotesCard from '../components/NotesCard'
import Masonry from '@mui/lab/Masonry'
import { useHistory } from 'react-router-dom'
import useFetch from '../customHooks/useFetch'
import { deleteDoc, doc, getFirestore } from 'firebase/firestore'
import { memo } from 'react'
import { NoteAddOutlined } from '@mui/icons-material'


function Notes({ setTitle, setDetails, setCategory, token }) {

  const db = getFirestore()
  
  const {data: notes, isPending, error, setData: setNotes} = useFetch(token)
  const history = useHistory()

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, `users/${token}/someNotes`, id))

    const newNotes = notes.filter(note => note.id !== id)
    setNotes(newNotes)
  }

  const handleEdit = async (id, title, details, category) => {
    setTitle(title)
    setDetails(details)
    setCategory(category)
    history.push('/create')

    await deleteDoc(doc(db, `users/${token}/someNotes`, id))
  }


  return (
    <Container>
      { error && <div>{ error }</div> }
      { isPending && <div>Loading...</div> }
      { notes && <Masonry columns={{ xs: 1, md: 3 }} spacing={1}>
        {notes.map(notes => (
          <div key={notes.id}>
            <NotesCard notes={notes} handleDelete={handleDelete} handleEdit={handleEdit} />
          </div>
        ))}
      </Masonry>}
      { !notes && (
        <div className='NoteIcon'>
          <NoteAddOutlined 
          style={{
            fontSize: '15rem',
            margin: 'auto',
            display: 'block',
            color: 'gray'
          }}
          onClick={() => history.push('/create')}
          />
        </div>
      )}
    </Container>
  )
}
export default memo(Notes)